import React from "react"

export const InfoLine = ({ value, className }) => {
    return <div className={className}>{value}</div>
}
